<div class="dialog-container ayuda-dialog">
  <div class="dialog-header" mat-dialog-title>
    <div class="title-dialog">
      <h2>
        @if (!ayuda.IdSubmoduloPermisoAyuda) {
          <span>{{ 'nuevo' | translate }}</span>
        }
        @if (ayuda.IdSubmoduloPermisoAyuda) {
          <span>{{ 'modificar' | translate }}</span>
        }
        <span>&nbsp;{{ 'ayuda' | translate | lowercase }}</span>
      </h2>
    </div>
    <div class="icon-close">
      <button
        matTooltip="{{ (expandedDialog ? 'minimizar' : 'expandir') | translate }}"
        color="primary"
        (click)="expandDialog()"
        mat-icon-button>
        @if (expandedDialog) {
          <mat-icon fontSet="material-symbols-outlined">close_fullscreen</mat-icon>
        }
        @if (!expandedDialog) {
          <mat-icon fontSet="material-symbols-outlined">aspect_ratio</mat-icon>
        }
      </button>
      <button
        color="warn"
        mat-icon-button
        matTooltip="{{ 'cerrar' | translate }}"
        matTooltipClass="colortooltip"
        [mat-dialog-close]>
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <mat-divider></mat-divider>

  <div class="dialog-body container-editors" [formGroup]="formAyuda" mat-dialog-content>
    <div [ngClass]="{ 'minimizar-utils': OcultarMostrar }" class="inputs-rows">
      <app-select-input-search
        id="modulos"
        [classList]="'mat w-50'"
        idName="idModulo"
        valueName="descripcion"
        formControlName="idModulo"
        [selectAllDesactive]="true"
        [options]="modulos"
        label="{{ 'Modulo' | translate }}">
      </app-select-input-search>

      <app-select-input-search
        id="submodulos"
        [classList]="'mat w-full'"
        idName="idSubmodulo"
        valueName="nombre"
        formControlName="IdSubmodulo"
        [selectAllDesactive]="true"
        [options]="submodulosFiltered"
        label="{{ 'submodulo' | translate }}">
      </app-select-input-search>

      <mat-form-field class="no-padding w-100" appearance="outline">
        <mat-label>{{ 'tipoPermiso' | translate }}</mat-label>
        <mat-select formControlName="IdPermisoTipo" [disableOptionCentering]="true">
          @for (tipo of tiposPermiso; track tipo) {
            <mat-option
              [value]="tipo.idPermisoTipo"
              [disabled]="hasHelpCreated(tipo.idPermisoTipo) && ayuda.IdPermisoTipo !== tipo.idPermisoTipo">
              {{ tipo.Nombre }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="document-mode-row">
      <mat-button-toggle-group
        [value]="documentMode"
        (change)="onDocumentModeChange($event.value)"
        aria-label="Tipo de documento">
        <mat-button-toggle value="simple">{{ 'help-document-simple' | translate }}</mat-button-toggle>
        <mat-button-toggle value="sections">{{ 'help-document-menu' | translate }}</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <div class="container-image-icon-disguise" [ngClass]="{ flotanteMaximizadoLinea: maximizado === true }">
      <img
        src="assets/imagenes/icons/UP_Mesa de trabajo 1.svg"
        [ngClass]="{ rotarAjustar: OcultarMostrar }"
        (click)="minimizarMaximizarHerramientas()"
        alt="icon hide editor options">
    </div>

    <mat-tab-group
      mat-stretch-tabs="false"
      mat-align-tabs="center"
      class="tab-group"
      [(selectedIndex)]="activeLangIndex"
      (selectedIndexChange)="onLangIndexChange($event)">
      @for (lang of langs; track lang.id; let i = $index) {
        <mat-tab [label]="lang.label | translate">
          <ng-template matTabContent>
            @if (documentMode === 'simple') {
              <div class="ck-editor-container">
                @if (isLayoutReady) {
                  <ckeditor
                    [formControlName]="lang.id"
                    [editor]="editor"
                    [config]="editorConfig"
                    (ready)="onEditorReady($event)"
                    (change)="onEditorContentChange(lang.id)">
                  </ckeditor>
                }
              </div>
            } @else {
              <app-help-section-editor
                [langId]="lang.id"
                [sections]="sectionsByLang[lang.id] ?? []"
                (sectionsChange)="onSectionsChange(lang.id, $event)">
              </app-help-section-editor>
            }
          </ng-template>
        </mat-tab>
      }
    </mat-tab-group>
  </div>

  <div mat-dialog-actions class="dialog-footer" align="end">
    <button (click)="guardarCambios()" mat-raised-button color="primary" [disabled]="!canSave">
      @if (!ayuda.IdSubmoduloPermisoAyuda) {
        <span>{{ 'create-ayuda' | translate }}</span>
      }
      @if (ayuda.IdSubmoduloPermisoAyuda) {
        <span>{{ 'modificar' | translate }}</span>
      }
    </button>
  </div>
</div>
